import styled from 'styled-components';

import BaseCheckbox from '@r1-frontend/ui-react/components/controls/baseCheckbox';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

export const CheckboxFilters = styled.div`
    display: flex;
    margin-left: 24px;

    @media (max-width: ${breakePoints.tablet}) {
        width: 100%;
        margin-top: 24px;
        margin-left: 0;
    }

    @media (max-width: ${breakePoints.mobile}) {
        flex-direction: column;
    }
`;

export const CheckboxWrap = styled.div`
    margin-left: 24px;
    user-select: none;
`;

export const SBaseCheckbox = styled(BaseCheckbox)`
    ${FONTS.MediumXS};
`;
